import ky from 'ky';
import orderBy from 'lodash/orderBy';
import { Query } from 'esri-leaflet';

const serviceUrl = 'https://gis.mono.ca.gov/webgis/rest/services/OpenData/CommunicationPlanning/MapServer';
const communicationProjects = '11';
const providers = '13';
const partners = '14';


export async function getPartners() {
  const query = new Query({
    url: `${serviceUrl}/${partners}`,
  });

  return await new Promise(async (resolve, reject) => {
    query
      .where('1=1')
      .run(async function (error, featureCollection) {
        if (error) {
          reject(error);
        } else {
          resolve(featureCollection.features);
          // resolve(orderBy(featureCollection.features, 'properties.Name'));
        }
      });
  });
}

export async function getProviders() {
  const query = new Query({
    url: `${serviceUrl}/${providers}`,
  });

  return await new Promise(async (resolve, reject) => {
    query
      .where('1=1')
      .orderBy('ProviderName', 'DESC')
      .run(async function (error, featureCollection) {
        if (error) {
          reject(error);
        } else {
          resolve(featureCollection.features);
        }
      });
  });

}

export function getProviderByGlobalID(id) {
  const url = 'https://gis.mono.ca.gov/webgis/rest/services/OpenData/CommunicationPlanning/MapServer/13/query';
  const searchParams = {
    f: 'json',
    where: `GlobalID='${id}'`,
    outFields: '*',
    outSR: 3857,
  };

  return ky.get(url, { searchParams })
    .json();
}

// https://sampleserver6.arcgisonline.com/arcgis/rest/services/Census/MapServer/3/query
// ?where=state_name%3d%27california%27&f=geojson

export async function requestServiceAreas() {
  const query = new Query({
    url: `${serviceUrl}/${communicationProjects}`,
  });

  return await new Promise(async (resolve, reject) => {
    query.where('1=1').run(async function (error, featureCollection) {
      if (error) {
        reject(error);
      } else {
        resolve(featureCollection.features);
      }
    });
  });

  // const searchParams = {
  //   f: 'json',
  //   where: '1=1',
  //   outFields: '*',
  //   outSR: 4326,
  //   orderByFields: 'Location',
  // };

  // const response = await ky.get(url, { searchParams })
  //   .json();

  // console.log(response);

  // return response;
}

export async function serviceAreaByPointIntersect({ inSpatialRef = 4326, x, y }) {
  console.log('serviceAreaByPointIntersect');
  console.log(x, y);

  const url = `${serviceUrl}/${communicationProjects}/query`;

  const searchParams = {
    f: 'geojson',
    geometryType: 'esriGeometryPoint',
    geometry: `${x},${y}`,
    spatialRel: 'esriSpatialRelIntersects',
    outFields: '*',
    inSR: inSpatialRef,
    outSR: 4326,
    // orderByFields: 'Location',
  };

  console.log(searchParams);

  const pointIntersectResponse = await ky.get(url, { searchParams })
    .json();

  console.log(pointIntersectResponse);

  return orderBy(pointIntersectResponse.features, ['properties.Speeds_mbps'], ['desc']);
}

export async function findAddressCandidates(query) {
  const url = 'https://gis.mono.ca.gov/webgis/rest/services/Address_Composite/GeocodeServer/findAddressCandidates';
  const searchParams = {
    f: 'json',
    singleLine: query,
    outFields: '*',
    outSR: 4326,
  };

  const response = await ky.get(url, { searchParams })
    .json();

  let candidates = response.candidates || [];

  if (!response.candidates.length) {
    // https://developers.arcgis.com/rest/geocode/api-reference/geocoding-find-address-candidates.htm
    const esriUrl = 'http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates';
    const response = await ky.get(esriUrl, { searchParams })
      .json();
    candidates = response.candidates || [];
  }

  return candidates;
}

export const requests = {
  getPartners,
  getProviders,
  requestServiceAreas,
  serviceAreaByPointIntersect,
  findAddressCandidates,
  getProviderByGlobalID,
};

export default requests;
